import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import { throttle, debounce } from 'underscore';

Snappy.Component.Navigation = class Navigation extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-navigation';
	}

	constructor(element) {
		super(element);
		this.menuIsActive = false;
	}

	setVars() {
		this.$hamburgerButton = this.$element.find('.menu-icon');
		this.$listItems = this.$element.find('.more-available');
		this.$topbarListItems = this.$element.find('.more-content:not(.extramenu__social-dropdown)');
		this.$moreFaSitesButton = this.$element.find('.topbar__link.more-content');
		this.$returnButtons = this.$element.find('.global-navigation__return-button');
		this.$returnTopbarButtons = this.$element.find('.topbar__return-button');
		this.$toggleSearchButton = this.$element.find('.global-navigation__toggle-search');
		this.$searchInput = this.$element.find('.site-search__input');
		this.$faLogo = this.$element.find('.logo-container');
		this.$userLink = this.$element.find('.user-button');
		this.hiddenClass = 'hidden';
		this.activeItemClass = 'active-item';
		this.$userDetailsContainer = this.$element.find('.signin-menu');
		this.$userButton = this.$userDetailsContainer.find('.user-button');
		this.$navigationContainer = this.$element.find('.navigation-container');
		this.$siteSearchButton = this.$element.find('.site-search__button');
		this.$siteSearchInput = this.$element.find('.site-search__input');
		this.$siteSearchPositioner = this.$element.find('.navigation-container__searchbar');
        this.$siteSearchClose = this.$element.find('.site-search__close');
        this.$stickyListItem = this.$element.find('.global-navigation__primary-list-item.list-item--sticky a.global-navigation__primary-link').clone();
        this.stickyClonedItem = this.$element.find('.sticky-cloned-item');
	}

	setEventListeners() {
		const onResizeEvent = throttle(this.onViewportResize.bind(this), 200);
		const onScrollEvent = throttle(this.onDocumentScroll.bind(this), 50);

		window.addEventListener('resize', onResizeEvent);
		window.addEventListener('scroll', onScrollEvent);
		window.addEventListener('keyup', this.onKeyupEvent.bind(this));
		this.$hamburgerButton.on('click', this.onHamburgerButtonClick.bind(this));
		this.$userLink.on('click', this.onUserLinkClick.bind(this));

		this.addListenersToMenuItems();
		this.$returnButtons.on('click', this.onReturnButtonClick.bind(this));
		this.$returnTopbarButtons.on('click', this.onReturnTopbarButtonClick.bind(this));
		this.$toggleSearchButton.on('click', this.onToggleSearchButtonClick.bind(this));
		this.$siteSearchClose.on('click', this.closeSearchBar.bind(this));
	}

	addEventListenersToListItemsAboveLargeViewport() {
		this.$primaryListItems = this.$listItems.filter('.global-navigation__primary-link');
		this.$subMenuListItems = this.$listItems.filter('.global-navigation__submenu-link');
		this.$topbarSubMenuListItems = this.$topbarListItems.filter('.topbar__submenu-link');
		this.$siteSearchClose.on('keydown', this.onTabbingOffSearch.bind(this));

		if (!this.isViewportBelowLarge) {
			this.$primaryListItems.on('mouseover focus click', this.onListItemHoverFocus.bind(this));
			this.$subMenuListItems.on('mouseover focus', this.onSubmenuListItemHoverFocus.bind(this));
			this.$moreFaSitesButton.on('mouseover focus', debounce(this.onTopbarListItemHoverFocus.bind(this), 200));
			this.$topbarSubMenuListItems.on('mouseover focus', this.onTopbarSubMenuListItemHoverFocus.bind(this));
		} else {
			this.$primaryListItems.off('mouseover focus');
			this.$subMenuListItems.off('mouseover focus');
			this.$topbarSubMenuListItems.off('mouseover focus');
		}
	}

	addListenersToMenuItems() {
		this.$listItems.on('click', this.onListItemClick.bind(this));
		this.$topbarListItems.on('click', this.onTopbarListItemClick.bind(this));
	}

	removeListenersFromMenuItems() {
		this.$listItems.off('click');
		this.$topbarListItems.off('click');
	}

	addEventListenerOutsideComponent() {
		this.$globalNavSubmenus = this.$element.find('.global-navigation__primary-list-item');
		this.$topnavSubmenus = this.$element.find('.topbar__menu-item');
		$(document).on('click touchstart', this.handleClicksOnDocument.bind(this));
	}

	onTabbingOffSearch(event) {
		if (event.key !== undefined && event.key === 9) {
			this.handleTabOffSearch();
		} else if (event.keyIdentifier !== undefined && event.keyIdentifier === 9) {
			this.handleTabOffSearch();
		} else if (event.keyCode !== undefined && event.keyCode === 9) {
			this.handleTabOffSearch();
		}
	}

	handleTabOffSearch() {
		window.setTimeout(() => {
			this.focusToSiteSearch();
		}, 50);
	}

	render() {
		this.setSection();
		this.setVars();
		this.setEventListeners();
		this.setViewportWidth();
		this.addEventListenersToListItemsAboveLargeViewport();
		this.addEventListenerOutsideComponent();
        this.queryUserStatus();
        this.stickyClonedItem.html(this.$stickyListItem);
	}

	setViewportWidth() {
		this.isViewportBelowLarge = this.$body.hasClass('eduhub-layout') ? window.matchMedia('(max-width: 1024px)').matches : window.matchMedia('(max-width: 991px)').matches;
    }

	onViewportResize() {
		this.setViewportWidth();
		this.removeListenersFromMenuItems();
		this.addListenersToMenuItems();
		this.addEventListenersToListItemsAboveLargeViewport();

		this.menuIsActive = false;
		this.searchIsActive = false;
		this.userMenuIsActive = false;
		this.toggleSearchBar();
		this.toggleUserMenu();
	}

	onHamburgerButtonClick() {
		this.menuIsActive = !this.menuIsActive;
		this.toggleGlobalNavigation();
	}

	toggleGlobalNavigation() {
		this.$element.toggleClass('fa-navigation--active', this.menuIsActive);
	}

	handleClicksOnDocument(event) {
		// Taps on '.more-available' link on iPad Pro on Safari have null values for event.toElement and event.relatedTarget, so include event.target also
		// Without event.target, the first conditional statememnt below was missing clicks on links and closing the menu as a result
		const toElement = event.toElement || event.relatedTarget || event.target;

		if (this.$activeMenuBlock && !$.contains(this.$activeMenuBlock[0], toElement)) {
			this.$globalNavSubmenus.removeClass(this.activeItemClass);
		}

		if (this.$activeTopbarBlock && !$.contains(this.$activeTopbarBlock[0], toElement)) {
			this.$topnavSubmenus.removeClass(this.activeItemClass);
			this.$activeTopbarBlock.removeClass(this.activeItemClass);
			this.$faLogo.removeClass(this.hiddenClass);
			this.$activeTopbarBlock.off('focusout');
			this.$activeTopbarBlock = null;
			this.isMoreSitesMenuOpen = false;
		}
	}

	onListItemClick(event) {
		const item = event && event.currentTarget;
		const $submenu = $(item).siblings('.global-navigation__submenu');

		if (this.isViewportBelowLarge) {
			if ($submenu.length) {
				event.preventDefault();
				$submenu.addClass('global-navigation__submenu--active');
				this.scrollToTopOfNavContainer();
			}
		}
	}

	onTopbarListItemClick(event) {
		const item = event && event.currentTarget;
		const $submenu = $(item).siblings('.topbar__submenu');

		if (this.isViewportBelowLarge) {
			if ($submenu.length) {
				event.preventDefault();
				$submenu.addClass('topbar__submenu--active');
				this.scrollToTopOfNavContainer();
			}
		}
	}

	scrollToTopOfNavContainer() {
		this.$navigationContainer.animate({ scrollTop: 0 }, 0);
	}

	showSubnavContainer($activeMenuBlock) {
		if ($activeMenuBlock) {
			$activeMenuBlock.addClass(this.activeItemClass);
		}
	}

	onListItemHoverFocus(event) {
		const item = event && event.currentTarget;
		this.$activeMenuBlock = $(item).closest('.global-navigation__primary-list-item');

		if (event.type === 'click' && this.$activeMenuBlock.hasClass(this.activeItemClass)) {
			let target = event.currentTarget.getAttribute('href');
			window.location.href = target;
			return;
		}

		if (event.type === 'mouseover') {
			this.subnavTimeout = setTimeout(() => {
				this.showSubnavContainer(this.$activeMenuBlock);
			}, 150);
		} else {
			this.showSubnavContainer(this.$activeMenuBlock);
			event.preventDefault();
		}

		this.$activeMenuBlock.on('mouseout focusout', this.onListItemBlur.bind(this));
	}

	onListItemBlur(event) {
		const toElement = event.toElement || event.relatedTarget;
		clearTimeout(this.subnavTimeout);

		if (this.$activeMenuBlock) {
			const toElementIsInContainingElementChildren = $.contains(this.$activeMenuBlock[0], toElement);

			if (!toElementIsInContainingElementChildren) {
				this.$activeMenuBlock.removeClass(this.activeItemClass);
				this.$activeMenuBlock.off('mouseout focusout');
				this.$activeMenuBlock = null;
			}
		}
	}

	onSubmenuListItemHoverFocus(event) {
		const item = event && event.currentTarget;

		this.$activeSubMenuBlock = $(item).closest('.global-navigation__submenu-list-item');
		this.$activeSubMenuBlock.addClass(this.activeItemClass);

		if (!this.isViewportBelowLarge) {
			this.updateSubnavHeight($(item));
		}

		this.$activeSubMenuBlock.on('mouseout focusout', this.onSubMenuListItemBlur.bind(this));
	}

	onSubMenuListItemBlur(event) {
		const toElement = event.toElement || event.relatedTarget;

		if (this.$activeSubMenuBlock) {
			const toElementIsInContainingElementChildren = $.contains(this.$activeSubMenuBlock[0], toElement);

			if (!toElementIsInContainingElementChildren) {
				this.$activeSubMenuBlock.removeClass(this.activeItemClass);
				this.$activeSubMenuBlock.off('mouseout focusout');
				this.$activeSubMenuBlock = null;
			}
		}
	}

	onTopbarListItemHoverFocus(event) {
		const item = event && event.currentTarget;

		if ($(item).hasClass('more-content')) {
			this.$activeTopbarBlock = $(item).closest('.topbar__menu-item');
			this.isMoreSitesMenuOpen = !this.isMoreSitesMenuOpen;
			this.$activeTopbarBlock.toggleClass(this.activeItemClass, this.isMoreSitesMenuOpen);
			this.$faLogo.toggleClass(this.hiddenClass, this.isMoreSitesMenuOpen);
			event.preventDefault();

			this.$activeTopbarBlock.on('mouseout focusout', this.onTopListItemBlur.bind(this));
		}
	}

	onTopListItemBlur(event) {
		const toElement = event.toElement || event.relatedTarget;

		if (this.$activeTopbarBlock) {
			var toElementIsInContainingElementChildren = $.contains(this.$activeTopbarBlock[0], toElement);

			if (!toElementIsInContainingElementChildren) {
				this.isMoreSitesMenuOpen = false;
				this.$activeTopbarBlock.removeClass(this.activeItemClass);
				this.$faLogo.removeClass(this.hiddenClass);
				this.$activeTopbarBlock.off('mouseout focusout');
				this.$activeTopbarBlock = null;
			}
		}
	}

	onTopbarSubMenuListItemHoverFocus(event) {
		const item = event && event.currentTarget;

		this.$activeTopbarSubmenuBlock = $(item).closest('.topbar__submenu-list-item');
		this.$activeTopbarSubmenuBlock.addClass(this.activeItemClass);

		this.$activeTopbarSubmenuBlock.on('mouseout focusout', this.onTopbarSubMenuListItemBlur.bind(this));
	}

	onTopbarSubMenuListItemBlur(event) {
		const toElement = event.toElement || event.relatedTarget;

		if (this.$activeTopbarSubmenuBlock) {
			const toElementIsInContainingElementChildren = $.contains(this.$activeTopbarSubmenuBlock[0], toElement);

			if (!toElementIsInContainingElementChildren) {
				this.$activeTopbarSubmenuBlock.removeClass(this.activeItemClass);
				this.$activeTopbarSubmenuBlock.off('mouseout focusout');
				this.$activeTopbarSubmenuBlock = null;
			}
		}
	}

	onReturnButtonClick(event) {
		const item = event && event.currentTarget;
		const $submenu = $(item).closest('.global-navigation__submenu');

		if ($submenu.length) {
			$submenu.removeClass('global-navigation__submenu--active');
		}
	}

	onReturnTopbarButtonClick(event) {
		//move this function into on above
		const item = event && event.currentTarget;
		const $submenu = $(item).closest('.topbar__submenu');

		if ($submenu.length) {
			$submenu.removeClass('topbar__submenu--active');
		}
	}

	onToggleSearchButtonClick() {
		this.searchIsActive = !this.searchIsActive;
		this.toggleSearchBar();

		if (this.searchIsActive) {
			window.setTimeout(() => {
				this.focusToSiteSearch();
			}, 300);
		} else {
			this.$siteSearchButton.attr('tabindex', '-1');
			this.$siteSearchInput.attr('tabindex', '-1');
		}
	}

	focusToSiteSearch() {
		this.$searchInput.focus();
		this.$siteSearchButton.attr('tabindex', '');
		this.$siteSearchInput.attr('tabindex', '');
		this.$siteSearchPositioner.addClass('active');
	}

	updateSubnavHeight($item) {
		const $tertiaryList = $item.siblings('.global-navigation__submenu-list-items-secondary');
		const $tertiaryItems = $tertiaryList && $tertiaryList.find('li');
		const $subNavContainer = $tertiaryList.parents('.global-navigation__submenu-primary');
		let totalHeight = 0;

		$tertiaryItems.each((i, el) => {
			totalHeight += $(el).outerHeight();
		});

		if (totalHeight >= $subNavContainer.outerHeight()) {
			$subNavContainer.css('height', totalHeight);
		} else {
			$subNavContainer.css('height', 'auto');
		}
	}

	toggleSearchBar() {
		this.$element.toggleClass('fa-navigation--searchbar-active', this.searchIsActive);

		if (!this.searchIsActive) {
			this.$siteSearchPositioner.removeClass('active');
		}
	}

	closeSearchBar() {
		this.searchIsActive = false;

		this.toggleSearchBar();
		this.$toggleSearchButton.focus();
	}

	onDocumentScroll() {
		this.stickyNavIsActive = this.$window.scrollTop() >= 30;

		this.toggleStickyNav();
	}

	toggleStickyNav() {
		this.$body.toggleClass('sticky-nav--active', this.stickyNavIsActive);
	}

	onUserLinkClick() {
		this.userMenuIsActive = !this.userMenuIsActive;

		this.toggleUserMenu();
	}

	toggleUserMenu() {
		this.$body.toggleClass('user-menu-active', this.userMenuIsActive);
	}

	queryUserStatus() {
		const signInUrl = this.$userButton.data('signInUrl');

		if (signInUrl) {
			$.ajax({
				method: 'GET',
				cache: false,
				url: signInUrl
			}).then(
				this.onUserStatusResponse.bind(this),
				this.onUserStatusError.bind(this)
			);
		}
	}

	onUserStatusResponse(response) {
		if (response && response.IsValid) {
			this.$userButton.text(response.Html);
			this.$userDetailsContainer.addClass('user-signed-in');
		}
	}

	onUserStatusError() {
	}

	onKeyupEvent(event) {
		if (event && event.keyCode === 27 && this.searchIsActive) {
			this.onToggleSearchButtonClick();
		}
	}

	setSection()
	{
		var currentItemPath = $(".currentItemPath").val();

		$(".global-navigation__primary-list-item").each(function(){
			var sectionPath = $(this).attr("data-sectionPath");

			if (currentItemPath != null && currentItemPath.indexOf(sectionPath) == 0)
			{
				$(this).addClass("current-section");
			}
		});
	}
};



// WEBPACK FOOTER //
// ./components/navigation/scripts/navigation.js